var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"evaluation-message"},[_c('div',{staticClass:"evaluation-message__heading"},[_vm._v(" Agradecemos muito! ")]),_c('IconHandHeart',{staticClass:"evaluation-message__image"}),_c('div',{staticClass:"evaluation-message__text",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }